import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
const ENV = process.env.NODE_ENV;

export const initMixpanel = () => {
  if (!MIXPANEL_TOKEN) {
    console.warn("Mixpanel token is missing!");
    return;
  }

  mixpanel.init(MIXPANEL_TOKEN, {
    debug: ENV !== "production", // Debug mode only in development
    track_pageview: true,
    persistence: "localStorage",
  });
};

export const trackEvent = (eventName, properties = {}) => {
  if (!MIXPANEL_TOKEN) return;
  mixpanel.track(`${eventName} - webapp`, properties);
};

export const identifyUser = (userId, userProperties = {}) => {
  if (!MIXPANEL_TOKEN) return;
  mixpanel.identify(userId);
  mixpanel.people.set(userProperties);
};
